var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1.25-12.5l-.214 5.833H8.964L8.75 5.5h2.5zm0 7.837c0 .66-.565 1.177-1.247 1.177-.694 0-1.253-.518-1.253-1.177 0-.653.559-1.17 1.253-1.17.682 0 1.247.517 1.247 1.17z",
    fill: "#999"
  })));
}
export default SvgExclamation;